import { GuideTemplateDefault } from "./guideTemplates/GuideTemplateDefault";
import { GuideTemplateCapioAhcStGoran } from "./guideTemplates/capioahc/StGoran";
import { GuideTemplateCapioAhcNorrtalje } from "./guideTemplates/capioahc/Norrtalje";
import { GuideTemplateCapioAhcTaby } from "./guideTemplates/capioahc/Taby";
import { GuideTemplateCapioAhcVasterort } from "./guideTemplates/capioahc/Vasterort";
import { GuideTemplateCapioAhcSollentuna } from "./guideTemplates/capioahc/Sollentuna";
import { GuideTemplateCapioAhcSodertalje } from "./guideTemplates/capioahc/Sodertalje";
import { GuideTemplateCapioAhcHaga } from "./guideTemplates/capioahc/Haga";
import { imagePathsCapioAhc } from "./guideTemplates/capioahc";
import { GuideTemplateSSHBromma } from "./guideTemplates/ssh/Bromma";
import { GuideTemplateSSHInnerstaden } from "./guideTemplates/ssh/Innerstaden";
import { imagePathsSsh } from "./guideTemplates/ssh";
import { GuideTemplateSUSLund } from "./guideTemplates/sus/Lund";
import { GuideTemplateSUSMalmo } from "./guideTemplates/sus/Malmo";
import { imagePathsSus } from "./guideTemplates/sus";
import { GuideTemplateHahag } from "./guideTemplates/GuideTemplateHahag";
import { GuideTemplateRakus } from "./guideTemplates/GuideTemplateRakus";
import { GuideTemplateKsgr } from "./guideTemplates/GuideTemplateKsgr";
import {
  imagePathsDefault,
  imagePathsHahag,
  imagePathsKsgr,
  imagePathsRakus,
} from "./guideTemplates/imagePaths";
import type { SiteId } from "@medoma/models/sites";
import { GuideTemplateCapioAhcDalen } from "./guideTemplates/capioahc/Dalen";
import { GuideTemplateCapioAhcHanden } from "./guideTemplates/capioahc/Handen";
import { GuideTemplateCapioAhcNacka } from "./guideTemplates/capioahc/Nacka";
import { GuideTemplateSlsoSolnaStrand } from "./guideTemplates/slso/SolnaStrand";
import { GuideTemplateSlsoDanderyd } from "./guideTemplates/slso/Danderyd";
import { GuideTemplateSlsoJarfalla } from "./guideTemplates/slso/Jarfalla";
import { GuideTemplateSlsoNacka } from "./guideTemplates/slso/Nacka";
import { GuideTemplateSlsoHanden } from "./guideTemplates/slso/Handen";
import { GuideTemplateSlsoHuddinge } from "./guideTemplates/slso/Huddinge";
import { GuideTemplateSlsoOst } from "./guideTemplates/slso/Ost";
import { GuideTemplateSlsoVast } from "./guideTemplates/slso/Vast";
import { imagePathsSlso } from "./guideTemplates/slso";

type IInformationText = {
  jsxText: React.ReactNode;
  imagePath: { 480: string; 768: string; 1366: string };
};

const capioAhc = {
  stGoran: {
    jsxText: <GuideTemplateCapioAhcStGoran />,
    imagePath: imagePathsCapioAhc,
  },
  norrtalje: {
    jsxText: <GuideTemplateCapioAhcNorrtalje />,
    imagePath: imagePathsCapioAhc,
  },
  taby: {
    jsxText: <GuideTemplateCapioAhcTaby />,
    imagePath: imagePathsCapioAhc,
  },
  vasterort: {
    jsxText: <GuideTemplateCapioAhcVasterort />,
    imagePath: imagePathsCapioAhc,
  },
  sollentuna: {
    jsxText: <GuideTemplateCapioAhcSollentuna />,
    imagePath: imagePathsCapioAhc,
  },
  dalen: {
    jsxText: <GuideTemplateCapioAhcDalen />,
    imagePath: imagePathsCapioAhc,
  },
  handen: {
    jsxText: <GuideTemplateCapioAhcHanden />,
    imagePath: imagePathsCapioAhc,
  },
  nacka: {
    jsxText: <GuideTemplateCapioAhcNacka />,
    imagePath: imagePathsCapioAhc,
  },
  sodertalje: {
    jsxText: <GuideTemplateCapioAhcSodertalje />,
    imagePath: imagePathsCapioAhc,
  },
  haga: {
    jsxText: <GuideTemplateCapioAhcHaga />,
    imagePath: imagePathsCapioAhc,
  },
};

const medoma = {
  vasastan: {
    jsxText: <GuideTemplateDefault />,
    imagePath: imagePathsDefault,
  },
  kungsholmen: {
    jsxText: <GuideTemplateDefault />,
    imagePath: imagePathsDefault,
  },
};

const hahag = {
  hhagZollikon: {
    jsxText: <GuideTemplateHahag />,
    imagePath: imagePathsHahag,
  },
};

const ksgr = {
  chur: {
    jsxText: <GuideTemplateKsgr />,
    imagePath: imagePathsKsgr,
  },
};

const ssh = {
  bromma: {
    jsxText: <GuideTemplateSSHBromma />,
    imagePath: imagePathsSsh,
  },
  innerstaden: {
    jsxText: <GuideTemplateSSHInnerstaden />,
    imagePath: imagePathsSsh,
  },
};

const slso = {
  solnastrand: {
    jsxText: <GuideTemplateSlsoSolnaStrand />,
    imagePath: imagePathsSlso,
  },
  danderyd: {
    jsxText: <GuideTemplateSlsoDanderyd />,
    imagePath: imagePathsSlso,
  },
  jarfalla: {
    jsxText: <GuideTemplateSlsoJarfalla />,
    imagePath: imagePathsSlso,
  },
  nacka: {
    jsxText: <GuideTemplateSlsoNacka />,
    imagePath: imagePathsSlso,
  },
  handen: {
    jsxText: <GuideTemplateSlsoHanden />,
    imagePath: imagePathsSlso,
  },
  huddinge: {
    jsxText: <GuideTemplateSlsoHuddinge />,
    imagePath: imagePathsSlso,
  },
  ost: {
    jsxText: <GuideTemplateSlsoOst />,
    imagePath: imagePathsSlso,
  },
  vast: {
    jsxText: <GuideTemplateSlsoVast />,
    imagePath: imagePathsSlso,
  },
};

const sus = {
  lund: {
    jsxText: <GuideTemplateSUSLund />,
    imagePath: imagePathsSus,
  },
  malmo: {
    jsxText: <GuideTemplateSUSMalmo />,
    imagePath: imagePathsSus,
  },
};

const rakus = {
  rakus: {
    jsxText: <GuideTemplateRakus />,
    imagePath: imagePathsRakus,
  },
};

const qa = {
  norra: {
    jsxText: <GuideTemplateDefault />,
    imagePath: imagePathsDefault,
  },
  sodra: {
    jsxText: <GuideTemplateDefault />,
    imagePath: imagePathsDefault,
  },
};

const allInformationTexts: Record<SiteId, IInformationText> = {
  ...capioAhc,
  ...medoma,
  ...hahag,
  ...ksgr,
  ...rakus,
  ...qa,
  ...slso,
  ...ssh,
  ...sus,
};

export const getInformationText = (siteId: SiteId): IInformationText => {
  return allInformationTexts[siteId];
};
